import { VoiceAgentRoom } from 'TutorBotVoiceAgent';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
    type LessonPlayerBotAudioUiContext,
    type ReviewPreviousMaterialVoiceAgentAttributes,
} from 'TutorBotAiTutorChat';
import { useIntroMessageLocales } from './useIntroMessageLocales';
import './locales/ReviewPreviousMaterialVoiceAgentRoom/ReviewPreviousMaterialIntro-en.json';

type Props = {
    toggleAudioOrText: () => void;
    autoStart: boolean;
    extraTokenAttributes: ReviewPreviousMaterialVoiceAgentAttributes;
    uiContext: LessonPlayerBotAudioUiContext;
    forceMorning?: boolean;
};

function ReviewPreviousMaterialVoiceAgentRoomComponent({
    toggleAudioOrText,
    autoStart,
    extraTokenAttributes,
    uiContext,
    forceMorning = false,
}: Props) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'TutorBotVoiceAgent.TutorBotVoiceAgent' });
    const { t: tIntro } = useTranslation('back_royal', {
        keyPrefix: 'ReviewPreviousMaterialVoiceAgentRoom.ReviewPreviousMaterialIntro',
    });

    const introMessageLocales = useIntroMessageLocales({ uiContext, forceMorning });

    const introMessages = useMemo(
        () => introMessageLocales.map(({ key, params = {} }) => tIntro(key, params)),
        [introMessageLocales, tIntro],
    );

    return (
        <VoiceAgentRoom
            agentIdentifier="reviewPreviousMaterial"
            extraTokenAttributes={extraTokenAttributes}
            abortFromRoom={toggleAudioOrText}
            abortText={t('switchToTextMode')}
            allowAbortDuringConversation
            uiContext={uiContext}
            introMessages={introMessages}
            autoStart={autoStart}
            postDiscussionButtonConfig={{ allowRestartDiscussion: true }}
        />
    );
}

export const ReviewPreviousMaterialVoiceAgentRoom = memo(
    ReviewPreviousMaterialVoiceAgentRoomComponent,
) as typeof ReviewPreviousMaterialVoiceAgentRoomComponent;
